import { createContext, useContext } from "react";

export const BasenameContext = createContext<string | null>(null);

export const useBasename = () => useContext(BasenameContext);

export const toBasenamePath = (path: string, basename = window.__webpack_public_path__) =>
  path.replace("/", basename);
